import { Controller } from 'stimulus'

export default class extends Controller {
  openDropzoneFilePicker() {
    this.element.querySelector('.dropzone').click()
  }
}
